const CounterData01 = [
    {
        number: {
            text: "135",
        },
        title: "Custom shortcodes",
        content: "SUPPORT NPOs VETTED FOR ADVANCED LEVELS",
        button: 'Support',
        list: [
            "Gift in-kind",
            "Purchase products",
            "Celebrate occasions",
            "Volunteer",
            "Donate money",
        ],
        navigation: ["PLATINUM" , "GOLD", "SILVER" , "BRONZE +" , "BRONZE"],
        image: "./Images/count1.png"
    },
    {
        number: {
            text: "700",
        },
        title: "Completed projects",
        content: "ENGAGE WITH NPOs VERIFIED FOR BASIC LEVEL",
        button: 'Engage',

        list: [
            
            "Gift in-kind",
            "Purchase products",
            "Celebrate occasions",
            "Volunteer",
            "Donate money",

        ],
        navigation: ["PLATINUM" , "GOLD", "SILVER" , "BRONZE +" , "BRONZE" , "basic"],
        image: "./Images/count2.png"
    },
    
    {
        number: {
            text: "12200",
        },
        title: "Completed projects",
        content: "DISCOVER NPOs VERIFIED FOR ENTRY LEVEL",
        list: [
            "Gift in-kind",
            "Purchase products",
            "Celebrate occasions",
            "Visit to learn more"
        ],
        navigation: ["PLATINUM" , "GOLD", "SILVER" , "BRONZE +" , "BRONZE" , "basic" ,"entry"],
        image: "./Images/count4.png",
        button: 'Discover',
    },
    {
        number: {
            text: "200000",
        },
        title: "Completed projects",
        content: "TRANSFORM THE SECTOR WITH OUR RESOURCES & RELATIONSHIPS"
        ,
        list: [
            "NPO Surveys & Outreach",
            "Research & Sector Reports",
            "NPO Data Standards & Taxonomies",
            "Sectoral Expertise for Collaborations",
            "Charity Reforms & Innovation",
        ],
        image: "./Images/count3.png",
        button: "Transform"
    },



]

const CounterData02 = [
    {
        number: {
            text: "2500",
        },
        title: "WORKING",
        content: "HOURS",
    },
    {
        number: {
            text: "3250",
        },
        title: "PHOTO",
        content: "CAPTURE",
    },
    {
        number: {
            text: "2800",
        },
        title: "WORK",
        content: "COMPLETED",
    },
    {
        number: {
            text: "2750",
        },
        title: "TELEPHONIC",
        content: "TALK",
    },
]

const CounterData03 = [
    {
        number: {
            text: "24",
        },
        title: "COUNTRIES",
    },
    {
        number: {
            text: "28",
        },
        title: "LANGUAGES",
    },
    {
        number: {
            text: "72",
        },
        title: "CHANNELS",
    },
    {
        number: {
            text: "92",
        },
        title: "BRANDS",
    },
]

const CounterData04 = [
    {
        number: {
            text: "220",
        },
        title: "PEOPLE",
    },
    {
        number: {
            text: "380",
        },
        title: "PROJECTS",
    },
    {
        number: {
            text: "700",
        },
        title: "CHANNELS",
    },
    {
        number: {
            text: "240",
        },
        title: "BRANDS",
    },
]

const CounterData05 = [
    {
        number: {
            text: "1227",
            class: "text-gradient bg-gradient-to-r from-[#556fff] to-[#e66176] inline-block"
        },
        title: "Winning awards",
        content: "For creative design",
    },
    {
        number: {
            text: "1947",
            class: "text-gradient bg-gradient-to-r from-[#556fff] to-[#e66176] inline-block"
        },
        title: "Working hours",
        content: "Desperate for work",
    },
    {
        number: {
            text: "1587",
            class: "text-gradient bg-gradient-to-r from-[#556fff] to-[#e66176] inline-block"
        },
        title: "Happy clients",
        content: "We love clients",
    },
]


export { CounterData01, CounterData02, CounterData03, CounterData04, CounterData05 }